export default function Contact() {
    return (
        <div class = 'content'>
            <div id = 'contact-info'>
                <p>Company Info</p>
                <ul>
                    <li>
                        Email: <a href = "mailto:snheni1593@outlook.com">snheni1593@outlook.com</a>
                    </li>
                    <li>
                        Hours of Operation:
                        <ul>
                            <li>Weekdays: 12:00 - 5:00 p.m. Pacific Standard Time</li>
                            <li>Saturday: 1:00 - 4:00 p.m. Pacific Standard Time</li>
                        </ul>
                    </li>
                </ul>
                <p>You can also contact me on Social Media!</p>
                <ul>
                    <li>
                        FaceBook: 
                        <a href = 'https://www.facebook.com/qian.lenington.3' target = '_blank' rel = 'noreferrer'>
                            Qian Lenington
                        </a>
                    </li>
                    <li>
                        <a href = 'https://www.instagram.com/Qian%20Lenington/?fbclid=IwAR1SA2FZz4TZZcqkU409_EfiG-EGqlK9Pbov5m7Qbw-JbOg0bXDYRANg_94' target = '_blank' rel = 'noreferrer'>
                            Instagram
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
}